import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgLag = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: "1280.000000pt",
	height: "1061.000000pt",
	viewBox: "0 0 1280.000000 1061.000000",
	preserveAspectRatio: "xMidYMid meet",
	...props,
	children: [/* @__PURE__ */ _jsx("metadata", { children: "\nCreated by potrace 1.15, written by Peter Selinger 2001-2017\n" }), /* @__PURE__ */ _jsx("g", {
		transform: "translate(0.000000,1061.000000) scale(0.100000,-0.100000)",
		fill: "currentColor",
		stroke: "none",
		children: /* @__PURE__ */ _jsx("path", { d: "M4650 8625 l0 -1985 940 0 940 0 -2 -512 -3 -513 -3128 0 -3127 0 0 -267 0 -268 1360 0 1360 0 0 -555 0 -555 -1010 0 -1010 0 0 -1985 0 -1985 2270 0 2270 0 0 1985 0 1985 -900 0 -900 0 0 555 0 555 3225 0 3225 0 0 -530 0 -530 -1025 0 -1025 0 0 -1985 0 -1985 2270 0 2270 0 0 1985 0 1985 -885 0 -885 0 0 530 0 530 825 0 825 0 0 268 0 267 -2640 -3 -2640 -2 0 515 0 515 970 0 970 0 0 1985 0 1985 -2270 0 -2270 0 0 -1985z m3830 0 l0 -1275 -1560 0 -1560 0 0 1275 0 1275 1560 0 1560 0 0 -1275z m3460 -6590 l0 -1275 -1560 0 -1560 0 0 1275 0 1275 1560 0 1560 0 0 -1275z m-7140 -50 l0 -1275 -1560 0 -1560 0 0 1275 0 1275 1560 0 1560 0 0 -1275z" })
	})]
});
export default SvgLag;
